import i18n from "../../../../../i18n"

export function returnReportErrorText (key) {
    switch (key) {
        case 'REPORT_ERROR_UNSPECIFIED': return i18n.t('reportErrorUnknown');
        case 'REPORT_ERROR_NULL': return '';
        case 'REPORT_ERROR_TIMEOUT': return i18n.t('reportErrorTimeOut');
        case 'REPORT_ERROR_DEVICE_PRESSURE': return i18n.t('reportErrorDevicePressure');
        case 'REPORT_ERROR_COLLECTING': return i18n.t('reportErrorCollecting');
        case 'REPORT_ERROR_DATA_FILE_UPLOADING': return i18n.t('reportErrorDataFileUploading');
        case 'REPORT_ERROR_ALGORITHM_INVOKE_ERROR': return i18n.t('reportErrorAlgorithmInvokeError');
        case 'REPORT_ERROR_DATA_NOT_FOUND': return i18n.t('reportErrorDataNotFound');
        case 'REPORT_ERROR_DATA_TOO_LESS': return i18n.t('reportErrorDataTooLess');
        case 'REPORT_ERROR_PRESSURE_PROCESSING': return i18n.t('reportErrorPressureProcessing');
        case 'REPORT_ERROR_DATA_FORMAT_ERROR': return i18n.t('reportErrorDataFormatError');
        case 'REPORT_ERROR_FOOTPRINT_NOT_FOUND': return i18n.t('reportErrorNoFootprints');
        case 'REPORT_ERROR_FOOTPRINTS_TOO_MESSY': return i18n.t('reportErrorFootprintsClutter');
        case 'REPORT_ERROR_NOT_IMPLEMENTED': return i18n.t('reportErrorMethodCannotBeImplement');
        case 'REPORT_ERROR_INTERNAL_SERVER': return i18n.t('reportErrorInternal');
        case 'REPORT_ERROR_INVALID_ARGUMENT': return i18n.t('reportErrorParameter');
        case 'REPORT_ERROR_FOOTSHAPE_PROCESSING': return i18n.t('reportErrorFootshapeProcessing')
        default: return i18n.t('reportErrorUnknown');
    }
}